export function resourceError(code) {
  const error = new Error(code);
  error.code = code;
  return error;
}

export function errorKind(error, online) {
  const status = error.response?.status;
  if (!status && !online) return "offline";
  if (["ECONNABORTED", "ETIMEDOUT"].includes(error.code) || [408, 504].includes(status)) return "timeout";
  if (error.code === "ERR_NETWORK") return "connection";
  if (error.code === "RESOURCE_NOT_FOUND" || [404, 410].includes(status)) return "notFound";
  if (error.code === "INVALID_RESPONSE") return "invalidResponse";
  if ([401, 403].includes(status)) return "access";
  if (status === 429) return "rateLimit";
  if (status === 409) return "conflict";
  if ([400, 422].includes(status)) return "validation";
  if (status >= 500) return "server";
  return "unknown";
}

export function describeError(error, operation, online, now = new Date()) {
  const kind = errorKind(error, online);
  const httpStatus = error.response ? error.response.status : null;
  const reason = httpStatus ? `HTTP_${httpStatus}` : kind.toUpperCase();
  return {
    kind,
    operation,
    httpStatus,
    code: `${operation.toUpperCase()}_${reason}`,
    occurredAt: now.toISOString(),
    retryable: !["notFound", "conflict", "validation", "invalidResponse"].includes(kind),
    uncertain: ["review", "newsletter"].includes(operation)
      && ["offline", "connection", "timeout", "server", "unknown", "invalidResponse"].includes(kind),
  };
}

export function shouldRetryRead(error, online) {
  if (!online || error.response?.headers?.["retry-after"]) return false;
  return error.response?.status === 401
    || ["connection", "timeout", "server"].includes(errorKind(error, online));
}
